import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/theme.css' // Import shared theme styles
import './styles/tooltip.css' // CSS-only tooltips ([data-tooltip])
import { installDebugLog } from './lib/debug-log'

// Antes de crear la aplicación: lo que se quiere leer luego en el modo
// depuración suele haber pasado durante el arranque.
installDebugLog()

const app = createApp(App)

const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes
      },
    },
  },
})

app.mount('#app')